import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { SevenSegment } from '../../base/zoo';
import { Grid, Cell } from '../../base/styled';

function timeDigits(unixTime, timeZone) {

  const localeTimeString = new Date(unixTime).toLocaleTimeString('en-US', { timeZone });
  const matches = localeTimeString.match(/(\d+):(\d+):(\d+)\s([AP])M/);

  if (matches) {
    let hh = matches[1];
    const mm = matches[2];
    const ss = matches[3];
    if (hh !== '12' && matches[4] === 'P') {
      hh = `${parseInt(hh, 10) + 12}`;
    }
    if (hh === '12' && matches[4] !== 'P') {
      hh = '0';
    }
    if (hh.length === 1) {
      hh = '0' + hh;
    }
    return `${hh}:${mm}:${ss}`;
  }
  return '';
}

function dateDigits(unixTime, timeZone) {
  const localeDateString = new Date(unixTime).toLocaleDateString('en-US', { timeZone });
  const matches = localeDateString.match(/(\d+)\/(\d+)\/(\d\d\d\d)/);
  if (matches) {
    const mm = parseInt(matches[1], 10);
    const month = ([null, 'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'])[mm];
    const dd = matches[2];
    const yyyy = matches[3];
    return `${yyyy}${month}${dd}`;
  }
  return '';
}


const Clock = (props) => {

  const { refreshInterval } = props;

  const [unixTime, setUnixTime] = useState(Date.now());

  const seconds = Math.floor(unixTime / 1000);

  setTimeout(() => { setUnixTime(Date.now()); }, refreshInterval);

  return (
    <div className="dashboard">
      <Grid columns={3} rows="50% 50%" alignContent="stretch" height="inherit">
        <Cell width={3}>
          <SevenSegment digits={timeDigits(unixTime, 'America/Denver')} color="#FFF" opacityOff={0.02} scale={8.0} translateY={75} />
          <h1 style={{ fontSize: '50pt' }}>
            MST7MDT&nbsp;&nbsp;
            { dateDigits(unixTime, 'America/Denver') }
          </h1>
        </Cell>
        <Cell width={1}>
          <div>
            <SevenSegment digits={`${seconds}`} scale={2.0} translateY={-10} />
            <h1>UNIX EPOCH</h1>
          </div>
        </Cell>
        <Cell width={1}>
          <div>
            <SevenSegment digits={timeDigits(unixTime, 'America/New_York')} scale={3.0} color="red" translateY={-10} />
            <h1 style={{ textAlign: 'center' }}>
              EST5EDT&nbsp;&nbsp;
              {dateDigits(unixTime, 'America/New_York')}
            </h1>
          </div>
        </Cell>
        <Cell width={1}>
          <div>
            <SevenSegment digits={timeDigits(unixTime, 'UTC')} scale={3.0} color="red" translateY={-10} />
            <h1 style={{ textAlign: 'center' }}>
              UTC&nbsp;&nbsp;
              {dateDigits(unixTime, 'UTC')}
            </h1>
          </div>
        </Cell>
      </Grid>
    </div>
  );
};

Clock.propTypes = { refreshInterval: PropTypes.number };

Clock.defaultProps = { refreshInterval: 500 };

export default Clock;
